module.exports = __webpack_public_path__ + "img/hot-bg.2875b2d7.png";